// removed by extract-text-webpack-plugin
module.exports = {"backdrop":"components-Modal-__index__backdrop__3syjC","dialog-wrapper":"components-Modal-__index__dialog-wrapper__23vdK","dialog":"components-Modal-__index__dialog__2JKwm","header-actions":"components-Modal-__index__header-actions__2-0AI","close-link":"components-Modal-__index__close-link__2ft9j","header":"components-Modal-__index__header__2Vdc3","body":"components-Modal-__index__body__1TnHI"};


//////////////////
// WEBPACK FOOTER
// ./components/Modal/index.css
// module id = 793
// module chunks = 0